import { useNavigate } from 'react-router-dom';
import { Wallet } from 'lucide-react';
import { useMemo } from 'react';
import { useUserAuth } from '@/contexts/UserAuthContext';
import { useCashbackTransactions, useUserProfile } from '@/hooks/useCashback';

export function CashbackPill() {
  const navigate = useNavigate();
  const { user } = useUserAuth();
  const { profile } = useUserProfile(user?.uid ?? null);
  const { transactions } = useCashbackTransactions(user?.uid ?? null);

  const summaryBalance = profile?.cashbackSummary?.availableBalance ?? 0;
  const confirmedNetFromTransactions = useMemo(
    () =>
      transactions.reduce((sum, tx) => {
        if (tx.status !== 'confirmed' && tx.status !== 'paid') return sum;
        const amount = Number(tx.cashbackAmount) || 0;
        const signed =
          tx.source === 'admin_adjustment' && tx.adjustmentSign === -1
            ? -amount
            : amount;
        return sum + signed;
      }, 0),
    [transactions],
  );
  const balance = Math.max(summaryBalance, confirmedNetFromTransactions);

  return (
    <button
      type="button"
      onClick={() => navigate('/cashback')}
      aria-label={`الكاش باك، الرصيد ${balance.toFixed(1)}`}
      className="flex min-w-[6rem] items-center justify-center gap-1.5 rounded-xl border border-primary/25 bg-primary/10 px-4 py-2 text-primary transition-colors hover:bg-primary/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
    >
      <Wallet className="h-4 w-4 shrink-0" strokeWidth={2} aria-hidden />
      <span className="tabular-nums text-sm font-semibold leading-none">
        {balance.toFixed(1)}
      </span>
    </button>
  );
}
